/** Default brand id used by Studio create flows (see Recipe / Ingredient). */
export const DEFAULT_DISH_BRAND_ID = "kocafe";
export const DISH_TITLE_MAX_LENGTH = 30;
export const DISH_DESCRIPTION_MAX_LENGTH = 300;

/** Canonical dish tag keys (API and client state). */
export const DishTagValue = {
	POPULAR: "POPULAR",
	CHEFS_SPECIAL: "CHEFS_SPECIAL",
	MUST_TRY: "MUST_TRY",
	SPICY: "SPICY",
};

export const DISH_TAGS = Object.freeze([
	DishTagValue.POPULAR,
	DishTagValue.CHEFS_SPECIAL,
	DishTagValue.MUST_TRY,
	DishTagValue.SPICY,
]);

/** Display label per canonical key. */
export const DISH_TAG_LABELS = Object.freeze({
	[DishTagValue.POPULAR]: "Popular",
	[DishTagValue.CHEFS_SPECIAL]: "Chef's special",
	[DishTagValue.MUST_TRY]: "Must try",
	[DishTagValue.SPICY]: "Spicy",
});